import React, { forwardRef, FormHTMLAttributes, FormEvent } from 'react';
import debounce from 'lodash/debounce';
import { FORM_DEFAULT_DEBOUNCE_TIME } from '../../utils/constants';

interface FormSubmitProps extends FormHTMLAttributes<HTMLFormElement> {
    debounceSubmit?: {
        time?: number;
        callback: (event: FormEvent<HTMLFormElement>) => void;
    };
    stopPropagation?: boolean;
    disableEnterSubmit?: boolean;
}

const FormSubmit = forwardRef<HTMLFormElement, FormSubmitProps>((props, ref) => {
    const { children, debounceSubmit, stopPropagation, disableEnterSubmit, onSubmit, ...rest } = props;

    // useRef remove the data state from the original component why ??
    // const delayedCallback = useRef(
    //     debounce(function (event) {
    //         debounceSubmit.callback(event);
    //     }, debounceSubmit?.time ?? FORM_DEFAULT_DEBOUNCE_TIME),
    // ).current;

    const delayedCallback = debounce((event: FormEvent<HTMLFormElement>) => {
        debounceSubmit?.callback(event);
    }, debounceSubmit?.time ?? FORM_DEFAULT_DEBOUNCE_TIME);

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.persist();
        event.preventDefault();
        if (stopPropagation) {
            event.stopPropagation();
        }
        delayedCallback(event);
    };

    return (
        <form
            ref={ref}
            onSubmit={debounceSubmit ? handleSubmit : onSubmit}
            onKeyDown={(e) => {
                const target = e.target as HTMLElement;
                const tagName = target?.tagName?.toUpperCase();

                if (disableEnterSubmit && e.key === 'Enter' && tagName !== 'TEXTAREA') {
                    e.preventDefault();
                }
            }}
            {...rest}
        >
            {children}
        </form>
    );
});

FormSubmit.displayName = 'FormSubmit';

export default FormSubmit;
